"use client";
import "./PricingSubpageSection1.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import BirdLogo from "../../../assets/Varlık 1 7.png";
import { useTranslation } from "react-i18next";

function PricingSubpageSection1(props) {
  const { t } = useTranslation("global");
  const { lang } = useParams();

  const {
    mainTitle,
    subtitleText,
    basicPlanTitle,
    basicPlanDescription,
    basicPlanFeatures,
    standardPlanTitle,
    standardPlanDescription,
    standardPlanFeatures,
    enterprisePlanTitle,
    enterprisePlanDescription,
    enterprisePlanFeatures,
  } = props;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="pricing-page-container">
      <div className="pricing-content-wrapper">
        <header className="pricing-header-section">
          <h1 className="pricing-main-title">{mainTitle}</h1>
          <p className="pricing-subtitle-text">{subtitleText}</p>
        </header>

        <section className="pricing-cards-grid">
          {/* Basic Plan */}
          <article className="pricing-card-item pricing-basic-card">
            <header className="card-header-block">
              <h2 className="card-title-text">{basicPlanTitle}</h2>
              <p className="card-description-text">{basicPlanDescription}</p>
            </header>

            <ul className="feature-list-container">
              {basicPlanFeatures.map((feature, index) => (
                <li key={index} className="feature-list-item">
                  <span className="bullet-point">•</span>
                  <span className="feature-text">{feature}</span>
                </li>
              ))}
            </ul>

            <Link
              to={`/${lang}/ContactUs`}
              onClick={scrollToTop}
              className="card-link"
            >
              <button className="cta-button-element basic-cta-button">
                {t("pricing-subpage.button")}{" "}
                <span className="arrow-icon">
                  <FontAwesomeIcon icon={faAngleRight} />
                </span>
              </button>
            </Link>
          </article>

          {/* Standard Plan */}
          <article className="pricing-card-item pricing-standard-card">
            <header className="card-header-block">
              <h2 className="card-title-text">{standardPlanTitle}</h2>
              <p className="card-description-text">{standardPlanDescription}</p>
            </header>

            <ul className="feature-list-container">
              {standardPlanFeatures.map((feature, index) => (
                <li key={index} className="feature-list-item">
                  <span className="bullet-point">•</span>
                  <span className="feature-text">{feature}</span>
                </li>
              ))}
            </ul>

            <Link
              to={`/${lang}/ContactUs`}
              onClick={scrollToTop}
              className="card-link"
            >
              <button className="cta-button-element standard-cta-button">
                {t("pricing-subpage.button")}{" "}
                <span className="arrow-icon">
                  <FontAwesomeIcon icon={faAngleRight} />
                </span>
              </button>
            </Link>
          </article>

          {/* Enterprise Plan */}
          <article className="pricing-card-item pricing-enterprise-card">
            <figure className="bird-logo-container">
              <img
                src={BirdLogo || "/placeholder.svg"}
                alt="Virtue Enterprise Plan Logo"
                className="bird-logo-image"
              />
            </figure>

            <header className="card-header-block">
              <h2 className="card-title-text">{enterprisePlanTitle}</h2>
              <p className="card-description-text enterprise-description">
                {enterprisePlanDescription}
              </p>
            </header>

            <ul className="feature-list-container enterprise-feature-list">
              {enterprisePlanFeatures.map((feature, index) => (
                <li key={index} className="enterprise-feature-item">
                  <span className="bullet-point">•</span>
                  {feature}
                </li>
              ))}
            </ul>

            <Link
              to={`/${lang}/ContactUs`}
              onClick={scrollToTop}
              className="card-link"
            >
              <button className="cta-button-element enterprise-cta-button">
                {t("pricing-subpage.button")}{" "}
                <span className="arrow-icon">
                  <FontAwesomeIcon icon={faAngleRight} />
                </span>
              </button>
            </Link>
          </article>
        </section>
      </div>
    </section>
  );
}

export default PricingSubpageSection1;
